(function () {
  'use strict';

  function initOurJourney(section) {
    if (!section) return;

    const slides = Array.from(section.querySelectorAll('.oj-slide'));
    const timelineItems = Array.from(section.querySelectorAll('.oj-timeline-item'));
    if (!slides.length || !timelineItems.length) return;

    let currentIndex = 0;
    let isAnimating = false;

    function goToSlide(index) {
      if (isAnimating || index === currentIndex) return;
      if (index < 0 || index >= slides.length) return;
      isAnimating = true;

      slides[currentIndex].classList.remove('is-active');
      timelineItems[currentIndex].classList.remove('is-active');

      slides[index].classList.add('is-active');
      timelineItems[index].classList.add('is-active');

      timelineItems[index].scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center',
      });

      currentIndex = index;

      setTimeout(function () {
        isAnimating = false;
      }, 550);
    }

    function bindTimeline() {
      timelineItems.forEach(function (item) {
        item.addEventListener('click', function () {
          const idx = parseInt(item.dataset.index, 10);
          goToSlide(idx);
        });
      });
    }

    function bindKeyboard() {
      section.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') {
          e.preventDefault();
          goToSlide((currentIndex + 1) % slides.length);
        } else if (e.key === 'ArrowLeft') {
          e.preventDefault();
          goToSlide((currentIndex - 1 + slides.length) % slides.length);
        }
      });
    }

    function bindSwipe() {
      let startX = 0;
      let isDragging = false;
      const sliderEl = section.querySelector('.oj-slides');
      if (!sliderEl) return;

      sliderEl.addEventListener(
        'touchstart',
        function (e) {
          startX = e.touches[0].clientX;
          isDragging = true;
        },
        { passive: true }
      );

      sliderEl.addEventListener(
        'touchend',
        function (e) {
          if (!isDragging) return;
          const diff = startX - e.changedTouches[0].clientX;
          isDragging = false;

          if (Math.abs(diff) < 40) return;

          if (diff > 0) {
            goToSlide((currentIndex + 1) % slides.length);
          } else {
            goToSlide((currentIndex - 1 + slides.length) % slides.length);
          }
        },
        { passive: true }
      );
    }

    bindTimeline();
    bindKeyboard();
    bindSwipe();
  }

  document.querySelectorAll('.our-journey').forEach(initOurJourney);
})();
